export default __webpack_public_path__ + "static/media/Department-Badge.ad091daa.gif";